export default __webpack_public_path__ + "static/media/key.2bc61903.svg";